/* Lofty · catálogo de singles: carga el catálogo completo, filtros y orden.
   Rareza y set salen de los datos de SortSwift (metafield custom.rarity y vendor) y se comparan exactos. */
(function(){
  var grid = document.getElementById('lsingles-grid');
  if (!grid || grid.getAttribute('data-lofty-all') === '1') return;
  grid.setAttribute('data-lofty-all', '1');

  var root = grid.closest('.lsingles');
  var TCG = (root && root.getAttribute('data-tcg')) || 'pokemon';
  var sidebar = root ? root.querySelector('.lsingles__sidebar') : null;
  var searchInput = document.getElementById('lsingles-search');
  var searchClear = document.getElementById('lsingles-clear');
  var countEl = document.getElementById('lsingles-count');
  var emptyEl = document.getElementById('lsingles-empty');
  var sortSel = document.getElementById('lsingles-sort');
  var MAX_PAGES = 60;
  var loading = false;

  var RARITY_ALIAS = {
    'p':'promo','pr':'promo','promotional':'promo',
    'c':'common','u':'uncommon','uc':'uncommon','r':'rare','rr':'double rare',
    'sr':'super rare','osr':'over super rare','sp':'super parallel','ssp':'super special parallel',
    'sec':'secret rare','tr':'treasure rare','l':'leader','don':'don!!'
  };
  var RARITY_ORDER = {
    riftbound: [['showcase','Showcase (alt art / overnumbered / firma)'],['epic','Epic'],['rare','Rare'],['uncommon','Uncommon'],['common','Common'],['promo','Promo']],
    one_piece: [['leader','Leader (L)'],['secret rare','Secret Rare (SEC)'],['treasure rare','Treasure Rare (TR)'],['super rare','Super Rare (SR)'],['rare','Rare (R)'],['uncommon','Uncommon (UC)'],['common','Common (C)'],['promo','Promo (P)'],['don!!','DON!!']],
    magic: [['mythic','Mythic Rare'],['rare','Rare'],['uncommon','Uncommon'],['common','Common'],['special','Special'],['promo','Promo']],
    gundam: [['lr++','LR++'],['lr+','LR+ (paralela)'],['lr','LR Legend Rare'],['r+','R+ (paralela)'],['r','R Rare'],['u+','U+ (paralela)'],['u','U Uncommon'],['c+','C+ (paralela)'],['c','C Common'],['promo','Promo (P)']],
    palworld: [['sss','SSS'],['super special parallel','Super Special Parallel (SSP)'],['super parallel','Super Parallel (SP)'],['over super rare','Over Super Rare (OSR)'],['super rare','Super Rare (SR)'],['tsr','Trial Deck Super Rare (TSR)'],['double rare','Double Rare (RR)'],['rare','Rare (R)'],['uncommon','Uncommon (U)'],['common','Common (C)'],['promo','Promo (PR)']],
    pokemon: [['mega hyper rare','Mega Hyper Rare'],['hyper rare','Hyper Rare'],['special illustration rare','Special Illustration Rare'],['futuristic rare','Futuristic Rare'],['illustration rare','Illustration Rare'],['shiny ultra rare','Shiny Ultra Rare'],['ultra rare','Ultra Rare'],['mega attack rare','Mega Attack Rare'],['ace spec rare','ACE SPEC Rare'],['shiny rare','Shiny Rare'],['double rare','Double Rare'],['pikachu rare','Pikachu Rare'],['classic collection','Classic Collection'],['secret rare','Secret Rare'],['rare','Rare'],['uncommon','Uncommon'],['common','Common'],['promo','Promo']]
  };

  function rarityKey(v){
    var k = (v || '').trim().toLowerCase();
    if (k === 'shiny holo rare') k = 'shiny rare';
    if (TCG === 'gundam') return k === 'p' ? 'promo' : k; // en Gundam C/U/R/LR son las rarezas oficiales tal cual
    return RARITY_ALIAS[k] || k;
  }
  // Respaldo: si SortSwift no mandó el metafield, se toma la rareza de las tags del producto.
  function rarityFromTags(card){
    var keys = (RARITY_ORDER[TCG] || []).map(function(o){ return o[0]; });
    var tags = (card.getAttribute('data-tags') || '').split(',');
    for (var i = 0; i < tags.length; i++) {
      var k = rarityKey(tags[i]);
      if (k && keys.indexOf(k) >= 0) return k;
    }
    return '';
  }
  function titleCase(s){ return s.replace(/\b\w/g, function(m){ return m.toUpperCase(); }); }
  function allCards(){ return Array.prototype.slice.call(grid.querySelectorAll('.lsingles-card')); }
  function isIn(c){ return !c.classList.contains('is-oos'); }

  var seen = {};
  var nextIdx = 0;
  function register(card){
    var a = card.querySelector('a.lsingles-card__link');
    var key = a ? a.getAttribute('href') : (card.getAttribute('data-name') || '') + '|' + nextIdx;
    if (seen[key]) return false;
    seen[key] = true;
    card.setAttribute('data-idx', nextIdx++);
    card.setAttribute('data-rkey', rarityKey(card.getAttribute('data-rarity')) || rarityFromTags(card));
    card.setAttribute('data-skey', (card.getAttribute('data-set') || '').trim().toLowerCase());
    return true;
  }
  allCards().forEach(register);

  function checkedVals(name){
    if (!sidebar) return [];
    return Array.prototype.slice.call(sidebar.querySelectorAll('input[data-filter="' + name + '"]:checked'))
      .map(function(i){ return i.value.toLowerCase(); });
  }

  // Arma las opciones (con conteo) a partir de las cartas cargadas, conservando lo que ya estaba marcado.
  function fillOptions(box, filterName, entries){
    if (!box) return;
    var keep = {};
    checkedVals(filterName).forEach(function(v){ keep[v] = true; });
    box.textContent = '';
    entries.forEach(function(e){
      var label = document.createElement('label');
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('data-filter', filterName);
      input.value = e[0];
      if (keep[e[0]]) input.checked = true;
      var count = document.createElement('span');
      count.className = 'lsingles__opt-count';
      count.textContent = e[2];
      label.appendChild(input);
      label.appendChild(document.createTextNode(' ' + e[1] + ' '));
      label.appendChild(count);
      box.appendChild(label);
    });
    var group = box.closest('details');
    if (group) group.style.display = entries.length ? '' : 'none';
  }

  function rebuildOptions(){
    if (!sidebar) return;
    var cards = allCards();
    var rc = {}, sc = {}, sLabel = {};
    cards.forEach(function(c){
      var r = c.getAttribute('data-rkey');
      if (r) rc[r] = (rc[r] || 0) + 1;
      var s = c.getAttribute('data-skey');
      if (s) { sc[s] = (sc[s] || 0) + 1; sLabel[s] = c.getAttribute('data-set'); }
    });
    var order = (RARITY_ORDER[TCG] || []).slice();
    var known = order.map(function(o){ return o[0]; });
    Object.keys(rc).sort().forEach(function(k){ if (known.indexOf(k) < 0) order.push([k, titleCase(k)]); });
    var rarities = order.filter(function(o){ return rc[o[0]]; }).map(function(o){ return [o[0], o[1], rc[o[0]]]; });
    var sets = Object.keys(sc).sort(function(a, b){ return (sc[b] - sc[a]) || sLabel[a].localeCompare(sLabel[b]); })
      .map(function(k){ return [k, sLabel[k], sc[k]]; });
    fillOptions(sidebar.querySelector('[data-rarity-options]'), 'rarity', rarities);
    fillOptions(sidebar.querySelector('[data-set-options]'), 'set', sets);
  }

  function applyFilters(){
    var q = ((searchInput && searchInput.value) || '').trim().toLowerCase();
    var sets = checkedVals('set');
    var rars = checkedVals('rarity');
    var types = checkedVals('type');
    var cols = checkedVals('color');
    var availOnly = checkedVals('availability').length > 0;
    var pr = sidebar ? sidebar.querySelector('input[name="price"]:checked') : null;
    var range = pr ? pr.value : 'all';
    if (searchClear) searchClear.classList.toggle('is-visible', q.length > 0);

    var visible = 0;
    allCards().forEach(function(card){
      var name = (card.getAttribute('data-name') || '').toLowerCase();
      var tags = (card.getAttribute('data-tags') || '').toLowerCase();
      var tagList = tags.split(',').map(function(t){ return t.trim(); });
      var price = parseFloat(card.getAttribute('data-price'));
      var avail = card.getAttribute('data-available') === 'true';
      var okPrice = range === 'all' ||
        (range === '0-15' && price <= 15) ||
        (range === '15-50' && price > 15 && price <= 50) ||
        (range === '50-150' && price > 50 && price <= 150) ||
        (range === '150+' && price > 150);
      var show = (!q || name.indexOf(q) >= 0) &&
        (!sets.length || sets.indexOf(card.getAttribute('data-skey')) >= 0) &&
        (!rars.length || rars.indexOf(card.getAttribute('data-rkey')) >= 0) &&
        (!types.length || types.some(function(t){ return tagList.indexOf(t) >= 0; })) &&
        // color: tag exacto o tag combinado sin espacios ("PurpleBlack"); así "Black" no atrapa el set "Black Bolt"
        (!cols.length || cols.some(function(c){ return tagList.some(function(t){ return t === c || (t.indexOf(' ') < 0 && t.indexOf(c) >= 0); }); })) &&
        (!availOnly || avail) && okPrice;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (countEl) countEl.textContent = visible + ' resultado' + (visible === 1 ? '' : 's') + (loading ? ' · cargando más cartas…' : '');
    if (emptyEl) emptyEl.style.display = (visible === 0 && !loading) ? 'block' : 'none';
  }

  function applySort(){
    var mode = sortSel ? sortSel.value : 'default';
    allCards().sort(function(a, b){
      var pa = parseFloat(a.getAttribute('data-price')), pb = parseFloat(b.getAttribute('data-price'));
      var na = a.getAttribute('data-name') || '', nb = b.getAttribute('data-name') || '';
      if (mode === 'price-asc') return pa - pb;
      if (mode === 'price-desc') return pb - pa;
      if (mode === 'name-asc') return na.localeCompare(nb);
      if (mode === 'name-desc') return nb.localeCompare(na);
      // Recomendado: en stock primero, respetando el orden de la colección
      var oa = isIn(a) ? 0 : 1, ob = isIn(b) ? 0 : 1;
      if (oa !== ob) return oa - ob;
      return parseInt(a.getAttribute('data-idx'), 10) - parseInt(b.getAttribute('data-idx'), 10);
    }).forEach(function(c){ grid.appendChild(c); });
  }

  function updateStats(){
    var cards = allCards();
    var total = root ? root.querySelector('.lsingles__stat strong') : null;
    var inStock = root ? root.querySelector('.lsingles__stat--green strong') : null;
    if (total) total.textContent = cards.length;
    if (inStock) inStock.textContent = cards.filter(isIn).length;
  }

  function resetAll(){
    if (searchInput) searchInput.value = '';
    if (sidebar) {
      Array.prototype.forEach.call(sidebar.querySelectorAll('input[type="checkbox"]'), function(c){ c.checked = false; });
      Array.prototype.forEach.call(sidebar.querySelectorAll('input[name="price"]'), function(r){ r.checked = r.value === 'all'; });
    }
    if (sortSel) sortSel.value = 'default';
    applySort();
    applyFilters();
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (searchClear) searchClear.addEventListener('click', function(){ searchInput.value = ''; applyFilters(); });
  if (sidebar) sidebar.addEventListener('change', applyFilters);
  if (sortSel) sortSel.addEventListener('change', function(){ applySort(); applyFilters(); });
  ['lsingles-reset', 'lsingles-reset2'].forEach(function(id){
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', resetAll);
  });

  // La sección solo pinta la primera página (200 cartas); el resto se trae en segundo plano.
  var sectionEl = grid.closest('.shopify-section');
  var sectionId = (sectionEl && sectionEl.id) ? sectionEl.id.replace(/^shopify-section-/, '') : null;
  function pageUrl(p){
    var url = new URL(window.location.href);
    url.searchParams.set('page', p);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  }
  function loadPage(p){
    return fetch(pageUrl(p), { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        if (!html) return 0;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var added = 0;
        Array.prototype.forEach.call(doc.querySelectorAll('#lsingles-grid .lsingles-card'), function(card){
          var node = document.importNode(card, true);
          if (register(node)) { grid.appendChild(node); added++; }
        });
        return added;
      });
  }
  function refresh(){ rebuildOptions(); applySort(); applyFilters(); updateStats(); }
  function finish(){ loading = false; refresh(); }
  function loadFrom(p){
    if (p > MAX_PAGES) { finish(); return; }
    loadPage(p).then(function(added){
      refresh();
      if (added > 0) loadFrom(p + 1); else finish();
    }).catch(finish);
  }

  var startPage = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10) || 1;
  loading = true;
  refresh();
  loadFrom(startPage + 1);

  // Agregar al carrito sin salir del catálogo (abre el drawer).
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('js-lsingles-add-form')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('button[type=submit]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},
      body: new FormData(form)
    })
    .then(function(res){ return res.ok ? res.json() : Promise.reject(res); })
    .then(function(){ return fetch('/?sections=cart-drawer,cart-icon-bubble', {headers:{'Accept':'application/json'}}); })
    .then(function(res){ return res.json(); })
    .then(function(sections){
      if (sections['cart-drawer']) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections['cart-drawer'].trim();
        var newDrawer = wrapper.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
        if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
      }
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); }
      else {
        var openBtn = document.querySelector('[aria-controls="cart-drawer"], .header__icon--cart');
        if (openBtn) openBtn.click();
      }
      if (btn) { btn.disabled = false; btn.textContent = '✓ Añadido'; setTimeout(function(){ btn.textContent = originalText; }, 1500); }
    })
    .catch(function(){
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
      form.submit();
    });
  });
})();